module.exports = __webpack_public_path__ + "img/nuki-box-lg.da333ab1.svg";